module.exports = __webpack_public_path__ + "img/_20.0a6c3e34.png";